"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredOptionsArray = exports.requiredOptionsSet = void 0;
/**
 * Available options for attributes required options as Set
 */
exports.requiredOptionsSet = new Set(['never', 'atLeastOnce', 'always']);
/**
 * Available options for attributes required options as Array
 */
exports.requiredOptionsArray = ['never', 'atLeastOnce', 'always'];
